export default __webpack_public_path__ + "static/media/clouds.4366e3a5.svg";